import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
export default {
  name: 'Empty',
  computed: _objectSpread({
    blocks() {
      return [{
        title: 'c.title',
        subtitle: 'c.subtitle',
        image: this.catalogImg,
        url: this.catalogLink
      }, {
        title: 't.title',
        subtitle: 't.subtitle',
        image: 'empty-tendances-deco-ah-2019.jpg',
        url: "/".concat(this.locale.market, "/").concat(this.locale.language, "/tendances-deco.htm")
      }, {
        title: 'cdc.title',
        image: 'empty-nouveautes.jpg',
        url: "/".concat(this.locale.market, "/").concat(this.locale.language, "/e/nouveautes")
      }];
    }

  }, mapGetters({
    locale: 'i18n/locale'
  }), {
    catalogLink() {
      if (this.locale.market === 'UK' || this.locale.market === 'PT') {
        return "/".concat(this.locale.market, "/").concat(this.locale.language, "/meubles-decoration.htm");
      }

      return "/".concat(this.locale.market, "/").concat(this.locale.language, "/e/nos-catalogues");
    },

    catalogImg() {
      if (this.locale.market === 'UK' || this.locale.market === 'PT') {
        return 'empty-collections-2019.jpg';
      }

      return 'empty-catalogues.jpg';
    }

  })
};